export const SLIDER_HEADER = 'Select a monthly benefit amount';
export const SLIDER_ERROR_MESSAGE = 'Must be greater than $0';

export const RECOMMENDATION_TEXT_BOLD =
  'We recommend the maximum coverage available, which is based on your income minus any existing coverage.';
export const RECOMMENDATION_TEXT =
  'If you end up changing the amount, just make sure it would be enough to cover your living expenses.';

export const ASK_HEADER = 'Why do we ask?';
export const ASK_EXPLAINER_TEXT =
  "We'll run quotes with a 'future increase option.' That allows you to increase your benefit amount when your income increases regardless of any changes in your health status.";
